import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  color: var(--light-red);
  font-size: 12px;
  line-height: 1.5;
  width: max-content;
`;

const ErrorLabel = ({ error, ...rest }) =>
  error ? (
    <ErrorContainer dir="ltr" {...rest}>
      {error}
    </ErrorContainer>
  ) : null;

ErrorLabel.defaultProps = {
  error: '',
};

ErrorLabel.propTypes = {
  error: PropTypes.string,
};

export default ErrorLabel;
